let _cache = null;

export function clearSchoolInfoCache() { _cache = null; }

export async function getSchoolInfo() {
  if (_cache) return _cache;
  try {
    const token = JSON.parse(localStorage.getItem('sms_auth') || '{}')?.token || '';
    const res   = await fetch('/api/school-settings', { headers: { Authorization: `Bearer ${token}` } });
    const data  = await res.json();
    _cache = {
      name:           data.name    || 'School Management System',
      address:        data.address || '',
      phone:          data.phone   || '',
      logo:           data.logo    || '',
      primaryColor:   data.primaryColor   || '#6b21a8',
      secondaryColor: data.secondaryColor || '#9333ea',
      hideFeeReceiptHeader: !!data.hideFeeReceiptHeader,
    };
  } catch {
    _cache = {
      name:           'School Management System',
      address:        '',
      phone:          '',
      logo:           '',
      primaryColor:   '#6b21a8',
      secondaryColor: '#9333ea',
      hideFeeReceiptHeader: false,
    };
  }
  return _cache;
}

export function schoolHeader(school, accentColor, heading = '') {
  const color = accentColor || school.primaryColor || '#6b21a8';
  const logoSrc = school.logo
    ? `${window.location.origin}${school.logo}`
    : `${window.location.origin}/school-logo.png`;
  const phoneLine = school.phone
    ? `<div style="font-size:13px;color:${color};font-weight:600;margin-top:2px">&#128222; ${school.phone}</div>`
    : '';
  const headingLine = heading
    ? `<div style="text-align:center;font-size:18px;font-weight:700;letter-spacing:1px;color:#374151;margin:10px 0 4px;text-transform:uppercase">${heading}</div>`
    : '';
  return `
    <div style="margin-bottom:14px">
      <div style="display:flex;align-items:center;justify-content:space-between;padding-bottom:10px;border-bottom:2px solid ${color};">
        <img src="${logoSrc}" style="height:78px;width:auto;object-fit:contain" onerror="this.style.display='none'" />
        <div style="text-align:right">
          <div style="color:${color};font-size:22px;font-weight:700;margin-bottom:2px">${school.name}</div>
          <div style="font-size:13px;color:${color};font-weight:600">${school.address}</div>
          ${phoneLine}
        </div>
      </div>
      ${headingLine}
    </div>`;
}
